import React, { FC } from 'react';
import LoadingIcon from 'src/assets/icons/LoadingIcon';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';
import { below, widthBreakpoints } from 'src/config/breakpoints';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import { StyleProps } from 'src/lib/styleProps';

const Container = styled.div`
  color: ${colors.red};
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const SimpleContentLoader: FC<StyleProps> = ({ style, className }) => {
  const notDesktop = useMediaQuery({ maxWidth: below(widthBreakpoints.px992) });
  return (
    <Container style={style} className={className}>
      <LoadingIcon size={notDesktop ? 32 : 64} />
    </Container>
  );
};
